import { v4 as uuidv4 } from "uuid";
import {
    generateNewChoice,
    questionsDefault,
    generateDefaultPage,
    generateSurveyTemplate,
} from "../../surveys";

const pages = [
    {
        ...generateDefaultPage(),
        questions: [
            {
                id: uuidv4(),
                ...questionsDefault["nps"],
                headline: "Overall, how would you rate the event?",
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline: "What is your job role?",
                choices: [
                    generateNewChoice("Excellent"),
                    generateNewChoice("Very good"),
                    generateNewChoice("Good"),
                    generateNewChoice("Fair"),
                    generateNewChoice("Poor"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["openText"],
                headline: "What did you like about the event?",
                longAnswer: true,
            },
            {
                id: uuidv4(),
                ...questionsDefault["openText"],
                headline: "What did you dislike about the event?",
                longAnswer: true,
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline: "How organized was the event?",
                choices: [
                    generateNewChoice("Extremely organized"),
                    generateNewChoice("Very organized"),
                    generateNewChoice("Somewhat organized"),
                    generateNewChoice("Not so organized"),
                    generateNewChoice("Not at all organized"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline: "How friendly was the staff?",
                choices: [
                    generateNewChoice("Extremely friendly"),
                    generateNewChoice("Very friendly"),
                    generateNewChoice("Somewhat friendly"),
                    generateNewChoice("Not so friendly"),
                    generateNewChoice("Not at all friendly"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline: "How helpful was the staff?",
                choices: [
                    generateNewChoice("Extremely helpful"),
                    generateNewChoice("Very helpful"),
                    generateNewChoice("Somewhat helpful"),
                    generateNewChoice("Not so helpful"),
                    generateNewChoice("Not at all helpful"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline:
                    "Prior to the event, how much of the information that you needed did you get?",
                choices: [
                    generateNewChoice("All of the information"),
                    generateNewChoice("Most of the information"),
                    generateNewChoice("Some of the information"),
                    generateNewChoice("A little of the information"),
                    generateNewChoice("None of the information"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline:
                    "Was the event length too long too short or about right?",
                choices: [
                    generateNewChoice("Much too long"),
                    generateNewChoice("Too long"),
                    generateNewChoice("About right"),
                    generateNewChoice("Too short"),
                    generateNewChoice("Much too short"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["openText"],
                headline:
                    "Is there anything else you’d like to share about the event?",
                longAnswer: true,
            },
        ],
    },
];
export const generalEventFeedbackSurveyTemplate = generateSurveyTemplate({
    name: "General Event Feedback survey",
    pages,
});
